import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHouse = () => {
  return (
    <g>
      <path d="M4.245 1a.75.75 0 0 1 .102 1.494l-.102.007h-.741v2.135l4.012-3.454a.75.75 0 0 1 .881-.072l.098.072L15.74 7.43a.75.75 0 0 1-.891 1.203l-.09-.066-.752-.65v6.034c0 .541-.409.987-.935 1.044l-.115.006H3.054a1.05 1.05 0 0 1-1.045-.936l-.006-.114V7.909l-.763.657a.75.75 0 0 1-.98 0l-.078-.08a.75.75 0 0 1 0-.979l.079-.078 1.742-1.501V1.75a.75.75 0 0 1 .649-.743L2.754 1h1.491zm3.76 1.74L3.503 6.616V13.5h2.001V7.757a.75.75 0 0 1 .65-.744l.101-.006h3.501a.75.75 0 0 1 .744.648l.006.102v5.742h2.001V6.692l.005-.066L8.005 2.74zm1 5.767h-2v4.992h2V8.507z" />
    </g>
  );
};

export default withIcon(IconHouse);
